// =============================================================================
// MOCK DATA — CMS-READY STRUCTURE
// Replace each export with a fetch() call to the backend when ready.
// =============================================================================

export const brand = {
  name: "Johnny Tan",
  fullName: "Johnny Tan · 陈健盛",
  advisor: "Johnny Tan",
  advisorChinese: "陈健盛",
  title: "Singapore Property Wealth Advisor",
  positioning:
    "HDB Resale | Condo Upgrade | Property Investment | Asset Progression Planning | Retirement-Focused Real Estate Strategies",
  cea: "R045634B",
  phone: "+65 8786 7270",
  phoneRaw: "6587867270",
  whatsapp: "https://wa.me/6587867270",
  domain: "www.johnnytan.sg",
  domainUrl: "https://www.johnnytan.sg",
  linktree: "https://linktr.ee/meproperty",
  // MeProperty logo retained only as a brand mark in nav/footer
  logoUrl:
    "https://customer-assets.emergentagent.com/job_97f0d41a-d399-4e78-8476-9f25ef5768ce/artifacts/zlxavqdv_ColorCode%20LOGO.png",
};

// Updated social links per spec (Linktree, GMB, LinkedIn, FB, IG, YouTube, TikTok)
export const socialLinks = [
  { label: "Linktree", icon: "fa-solid fa-link", url: "https://linktr.ee/meproperty" },
  { label: "Google My Business", icon: "fa-brands fa-google", url: "https://share.google/UpFsehObB3Gpgb8Xb" },
  { label: "LinkedIn", icon: "fa-brands fa-linkedin-in", url: "https://www.linkedin.com/in/johnnytan6886/" },
  { label: "Facebook", icon: "fa-brands fa-facebook-f", url: "https://www.facebook.com/JTPropertyRealtor" },
  { label: "Instagram", icon: "fa-brands fa-instagram", url: "https://www.instagram.com/johnnytanks/" },
  { label: "YouTube", icon: "fa-brands fa-youtube", url: "https://youtube.com/@meproperty685" },
  { label: "TikTok", icon: "fa-brands fa-tiktok", url: "https://www.tiktok.com/@johnnytan6886" },
];

export const portraits = [
  "https://customer-assets.emergentagent.com/job_97f0d41a-d399-4e78-8476-9f25ef5768ce/artifacts/sbtwtdlf_230923%20v2%20Full%20no%20logo.jpg",
  "https://customer-assets.emergentagent.com/job_97f0d41a-d399-4e78-8476-9f25ef5768ce/artifacts/39kwqv57_230923%20v3%20full%20no%20logo.jpg",
  "https://customer-assets.emergentagent.com/job_97f0d41a-d399-4e78-8476-9f25ef5768ce/artifacts/sxrwhwjr_230923%20v4%20full%20no%20logo.jpg",
  "https://customer-assets.emergentagent.com/job_97f0d41a-d399-4e78-8476-9f25ef5768ce/artifacts/btgtl6o2_230923%20v5%20full%20no%20logo.jpg",
];

export const trustHighlights = [
  { label: "Years in real estate", value: 13, suffix: "+" },
  { label: "Transactions handled", value: 280, suffix: "+" },
  { label: "Active since", value: 2012, suffix: "", static: true },
];

// Single composite artwork (sprite) containing all 6 advisory icons.
// Individual icons are pre-cropped to /public/advisory-icons/*.{webp,png} for
// crisp rendering on retina screens. WebP first, PNG fallback via <picture>.
export const advisoryAreas = [
  {
    title: "HDB Resale Advisory",
    desc: "Resale positioning, pricing strategy, and transaction management.",
    alt: "Singapore HDB resale advisory strategy icon",
    iconPng: "/HomePage-icons/1.png",
  },
  {
    title: "HDB to Condo Upgrading Strategy",
    desc: "Plan your transition from HDB to private with full financial clarity.",
    alt: "HDB to condo upgrading planning icon",
    iconPng: "/HomePage-icons/2.png",
  },
  {
    title: "Singapore Property Investment Planning",
    desc: "Data-led acquisition focused on yield and capital growth.",
    alt: "Singapore property investment planning icon",
    iconPng: "/HomePage-icons/3.png",
  },
  {
    title: "Property Asset Progression Strategy",
    desc: "Multi-stage planning to grow your family's property base.",
    alt: "Property asset progression wealth strategy icon",
    iconPng: "/HomePage-icons/4.png",
  },
  {
    title: "Property Exit & Wealth Restructuring",
    desc: "Know when, how, and why to exit before you ever enter.",
    alt: "Property exit and wealth restructuring strategy icon",
    iconPng: "/HomePage-icons/5.png",
  },
  {
    title: "Retirement Property Income Planning",
    desc: "Structure property income for stability in later years.",
    alt: "Retirement property income planning icon",
    iconPng: "/HomePage-icons/6.png",
  },
];

// C.L.A.R.I.T.Y Framework
export const clarityFramework = [
  {
    letter: "C",
    word: "Clarify Goals",
    desc: "Understand the client's family needs, financial position, property timeline, and long-term wealth objectives.",
    iconWebp: "/clarity-icons/C.png",
    iconPng: "/clarity-icons/C.png",
    alt: "Clarify property goals — target with arrow icon",
  },
  {
    letter: "L",
    word: "Leverage Market Data",
    desc: "Use real transaction data, supply trends, rental performance, and entry-price analysis to identify stronger opportunities.",
    iconWebp: "/clarity-icons/L.png",
    iconPng: "/clarity-icons/L.png",
    alt: "Leverage market data — rising bar chart with arrow icon",
  },
  {
    letter: "A",
    word: "Assess Risk",
    desc: "Evaluate affordability, SSD timeline, interest rate exposure, liquidity, and downside scenarios before making decisions.",
    iconWebp: "/clarity-icons/A.png",
    iconPng: "/clarity-icons/A.png",
    alt: "Assess risk — navy and gold shield with checkmark icon",
  },
  {
    letter: "R",
    word: "Roadmap Asset Progression",
    desc: "Plan the next property move based on HDB MOP, upgrading potential, portfolio growth, and retirement readiness.",
    iconWebp: "/clarity-icons/R.png",
    iconPng: "/clarity-icons/R.png",
    alt: "Roadmap asset progression — winding road to city skyline icon",
  },
  {
    letter: "I",
    word: "Identify Exit Strategy",
    desc: "Assess future resale demand, holding period, capital appreciation potential, and likely buyer profile before entry.",
    iconWebp: "/clarity-icons/I.png",
    iconPng: "/clarity-icons/I.png",
    alt: "Identify exit strategy — magnifying glass over chart icon",
  },
  {
    letter: "T",
    word: "Tailor the Recommendation",
    desc: "Recommend strategies based on each client's unique life stage, income, goals, and risk profile.",
    iconWebp: "/clarity-icons/T.png",
    iconPng: "/clarity-icons/T.png",
    alt: "Tailor the recommendation — clipboard with checklist and pen icon",
  },
  {
    letter: "Y",
    word: "Yield Long-Term Wealth",
    desc: "Focus on sustainable capital growth, rental income potential, financial stability, and generational wealth.",
    iconWebp: "/clarity-icons/Y.png",
    iconPng: "/clarity-icons/Y.png",
    alt: "Yield long-term wealth — gold leaf tree icon",
  },
];

export const consultingServices = [
  {
    icon: "fa-solid fa-chart-pie",
    iconPng: "/services-icons/portfolio Growth.png",
    alt: "Portfolio growth — rising bar chart with arrow and pie chart icon",
    title: "Portfolio Growth",
    desc: "Multi-property planning that compounds equity, cash-flow, and capital appreciation.",
  },
  {
    icon: "fa-solid fa-shield-halved",
    iconPng: "/services-icons/Risk mamangement.png",
    alt: "Risk management — gold shield with checkmark icon",
    title: "Risk Management",
    desc: "Affordability, SSD timing, interest rates, and downside scenarios assessed upfront.",
  },
  {
    icon: "fa-solid fa-user-tie",
    iconPng: "/services-icons/Personalized Service.png",
    alt: "Personalized service — gold-ringed client profile with star icon",
    title: "Personalized Service",
    desc: "Every plan is built around your unique life stage, family, and risk profile.",
  },
  {
    icon: "fa-solid fa-chart-line",
    iconPng: "/services-icons/market expertise.png",
    alt: "Market expertise — magnifying glass over rising chart icon",
    title: "Market Expertise",
    desc: "Real transaction data, supply trends, and rental performance drive every call.",
  },
  {
    icon: "fa-solid fa-microscope",
    iconPng: "/services-icons/project analysis.png",
    alt: "Project analysis — clipboard with property data and magnifying glass icon",
    title: "Project Analysis",
    desc: "Deep-dive analysis on new launches and resale projects before you commit.",
  },
  {
    icon: "fa-solid fa-flag-checkered",
    iconPng: "/services-icons/exit plan.png",
    alt: "Exit plan — open door with gold dollar block and coins icon",
    title: "Exit Plan",
    desc: "Every entry is paired with a clear, time-bound exit scenario.",
  },
];

export const marketingSolutions = [
  {
    icon: "fa-solid fa-mobile-screen",
    iconWebp: "/marketing-icons/01-social-media.webp",
    iconPng: "/marketing-icons/01-social-media.png",
    alt: "Social media campaigns — megaphone with smartphone and Facebook, Instagram, TikTok icons",
    title: "Social Media Campaigns",
    desc: "Targeted Facebook, Instagram & TikTok campaigns to reach qualified buyers fast.",
  },
  {
    icon: "fa-brands fa-youtube",
    iconWebp: "/marketing-icons/02-youtube.webp",
    iconPng: "/marketing-icons/02-youtube.png",
    alt: "YouTube showcase — clapperboard with red play button icon",
    title: "YouTube Showcase",
    desc: "Cinematic video tours that put your property on the largest video platform.",
  },
  {
    icon: "fa-solid fa-globe",
    iconWebp: "/marketing-icons/03-listing-platforms.webp",
    iconPng: "/marketing-icons/03-listing-platforms.png",
    alt: "Listing platforms — navy globe with gold location pin icon",
    title: "Listing Platforms",
    desc: "Premium placement across PropertyGuru, SRX, 99.co and EdgeProp.",
  },
  {
    icon: "fa-solid fa-camera",
    iconWebp: "/marketing-icons/04-photography.webp",
    iconPng: "/marketing-icons/04-photography.png",
    alt: "Photography and videography — DSLR camera with drone and property photos icon",
    title: "Photography & Videography",
    desc: "Professional imagery, drone footage, and floor plans that sell faster.",
  },
  {
    icon: "fa-solid fa-people-arrows",
    iconWebp: "/marketing-icons/05-buyer-pivoting.webp",
    iconPng: "/marketing-icons/05-buyer-pivoting.png",
    alt: "Buyer pivoting strategies — target with arrow and buyer figures icon",
    title: "Buyer Pivoting Strategies",
    desc: "Dynamic positioning to broaden buyer pools when the market shifts.",
  },
  {
    icon: "fa-solid fa-arrow-trend-up",
    iconWebp: "/marketing-icons/06-project-exit.webp",
    iconPng: "/marketing-icons/06-project-exit.png",
    alt: "Project analysis and exit plan — clipboard with rising chart and magnifying glass icon",
    title: "Project Analysis & Exit Plan",
    desc: "Sales-side strategy paired with future-buyer profiling for stronger exits.",
  },
];

// Stock images (Unsplash) for property placeholders
const propertyImages = [
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=900&q=80",
  "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=900&q=80",
  "https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=900&q=80",
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80",
  "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=900&q=80",
  "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=900&q=80",
  "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&q=80",
  "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=900&q=80",
];

export const listings = [
  { id: "lst-001", title: "Modern 3-Bedder Near Orchard", location: "District 9 · River Valley", price: "S$2,180,000", bedrooms: 3, bathrooms: 2, size: "1,109 sqft", type: "Condo (Resale)", image: propertyImages[1], description: "Freehold private condo within walking distance to Orchard MRT.", externalLink: "#" },
  { id: "lst-002", title: "Spacious HDB 5-Room Resale", location: "Punggol Central", price: "S$680,000", bedrooms: 3, bathrooms: 2, size: "1,200 sqft", type: "HDB (Resale)", image: propertyImages[6], description: "Well-maintained 5-room HDB with high floor, sheltered to MRT.", externalLink: "#" },
  { id: "lst-003", title: "Investor-Friendly 1-Bedder", location: "District 14 · Geylang", price: "S$880,000", bedrooms: 1, bathrooms: 1, size: "527 sqft", type: "Condo (Investment)", image: propertyImages[2], description: "Compact unit with strong rental demand near Aljunied MRT.", externalLink: "#" },
];

// Case studies = Proven Results
export const caseStudies = [
  {
    id: "cs-001",
    headline: "HDB Upgrader → Condo + Rental Investment",
    propertyType: "HDB resale → Private condo + Investment unit",
    challenge: "Young couple completing MOP, wanting to upgrade and also start an investment portfolio without overcommitting.",
    strategy: "Sequential plan: sell HDB at peak window, decouple to acquire 3BR own-stay, then 1BR investment with rental income covering instalment.",
    outcome: "+S$220k portfolio uplift within 18 months. Both units cash-flow neutral or positive.",
    metric: "+S$220k portfolio uplift",
    image: propertyImages[1],
  },
  {
    id: "cs-002",
    headline: "Avoided a Negative-Sale Exit",
    propertyType: "Private condo",
    challenge: "Owner under pressure to sell at break-even due to perceived market weakness.",
    strategy: "Reframed timing using transaction data and supply pipeline. Repositioned listing, deferred sale by 14 months.",
    outcome: "Exited at +9% versus the earlier proposed sale price. Capital redeployed into a yield-focused unit.",
    metric: "+9% exit price",
    image: propertyImages[5],
  },
  {
    id: "cs-003",
    headline: "First-Time Buyer — Investor Mindset",
    propertyType: "1-bedroom condo (resale)",
    challenge: "Single buyer torn between a lifestyle 2BR and a yield-friendly 1BR.",
    strategy: "Walked through 10-year hold scenarios, rental demand, and resale liquidity for both options.",
    outcome: "Tenant secured within 10 days of completion. 4.2% gross yield with strong location liquidity.",
    metric: "4.2% gross yield",
    image: propertyImages[2],
  },
  {
    id: "cs-004",
    headline: "Family Asset Progression",
    propertyType: "HDB → Executive Condo → Freehold private",
    challenge: "Multi-generational household needing space without compromising long-term wealth.",
    strategy: "Three-stage plan executed over 8 years: HDB sale → EC → freehold private. Equity recycled at each step.",
    outcome: "Family wealth secured across two generations with the freehold asset positioned for legacy planning.",
    metric: "3-stage plan executed",
    image: propertyImages[4],
  },
];

export const testimonials = [
  {
    id: "t-001",
    name: "Kristy Lee",
    role: "Homeowner",
    quote: "Johnny is a knowledgeable and experienced agent.",
    photo: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1400&q=80",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=240&q=80",
  },
  {
    id: "t-002",
    name: "Marican A.",
    role: "Investor",
    quote: "Johnny is professional and is a very good advisor. I engaged his services as well as recommended him to my close friends, and all of them have given great feedback.",
    photo: "https://images.unsplash.com/photo-1573497491208-6b1acb260507?w=1400&q=80",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=240&q=80",
  },
  {
    id: "t-003",
    name: "Devon C",
    role: "First-time Buyer",
    quote: "Big thanks to Johnny, he was very patient and detailed in explaining the crucial little details before purchasing a house.",
    photo: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1400&q=80",
    avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=240&q=80",
  },
];

// Awards — image-only masonry gallery. Backend will provide uploadedAt for sort.
// Frontend already sorts by uploadedAt desc (newest first).
export const awards = [
  { id: "a-001", title: "PROPNEX TOP 20%", year: "2020", uploadedAt: "2020-12-01", image: "https://images.unsplash.com/photo-1567427018141-0584cfcbf1b8?w=900&q=80" },
  { id: "a-002", title: "PROPNEX TOP 20%", year: "2019", uploadedAt: "2019-12-01", image: "https://images.unsplash.com/photo-1579532582937-16c108930bf6?w=900&q=80" },
  { id: "a-003", title: "PROPNEX TOP 20%", year: "2018", uploadedAt: "2018-12-01", image: "https://images.unsplash.com/photo-1607893407370-3d9c5d5b6d29?w=900&q=80" },
  { id: "a-004", title: "ERA TOP 87TH POSITION", year: "2016", uploadedAt: "2016-12-01", image: "https://images.unsplash.com/photo-1551214012-84f95e060dee?w=900&q=80" },
  { id: "a-005", title: "ERA TOP 34TH POSITION", year: "2015", uploadedAt: "2015-12-01", image: "https://images.unsplash.com/photo-1518544866330-95a2bec01f55?w=900&q=80" },
  { id: "a-006", title: "ERA TOP 49TH POSITION", year: "2014", uploadedAt: "2014-12-01", image: "https://images.unsplash.com/photo-1542744095-291d1f67b221?w=900&q=80" },
];

export const blogCategories = [
  "Residential Property Updates",
  "Commercial Property Updates",
  "Regulation & Policy Updates",
  "Market Insights",
  "Others",
];

export const blogPosts = [
  { id: "b-001", slug: "right-time-upgrade-hdb-to-condo", title: "When Is the Right Time to Upgrade from HDB to Condo?", category: "Residential Property Updates", excerpt: "A practical framework for deciding when (and whether) to upgrade — affordability, MOP, ABSD, and lifestyle factors all matter.", date: "Nov 2025", image: propertyImages[6] },
  { id: "b-002", slug: "entry-price-vs-exit-strategy", title: "Entry Price vs Exit Strategy: What Every Buyer Should Know", category: "Market Insights", excerpt: "Most buyers obsess over entry price. The real wealth lies in a well-planned exit.", date: "Oct 2025", image: propertyImages[1] },
  { id: "b-003", slug: "rental-yield-singapore", title: "How to Think About Rental Yield in Singapore", category: "Residential Property Updates", excerpt: "Gross yield, net yield, and total return — a clear breakdown for first-time landlords.", date: "Sep 2025", image: propertyImages[2] },
  { id: "b-004", slug: "mop-ssd-timing", title: "MOP, SSD and Timing: Planning Your Property Move", category: "Regulation & Policy Updates", excerpt: "Understanding regulatory timelines is half the battle in residential property planning.", date: "Aug 2025", image: propertyImages[7] },
  { id: "b-005", slug: "homeowner-to-investor", title: "From Homeowner to Property Investor: The First Step", category: "Market Insights", excerpt: "The mindset shift from buying for lifestyle to buying for wealth is where every investor begins.", date: "Jul 2025", image: propertyImages[4] },
  { id: "b-006", slug: "retirement-property-strategy", title: "Property as a Retirement Vehicle: What Works", category: "Others", excerpt: "How to structure property income to support a stable retirement in Singapore.", date: "Jun 2025", image: propertyImages[5] },
];

export const listingPortals = [
  { name: "PropertyGuru", url: "https://www.propertyguru.com.sg/agent/johnny-tan-338054", description: "Singapore's leading property marketplace", img: "/ListingPage_Johnny listing-icons/1.png" },
  { name: "EdgeProp", url: "https://www.edgeprop.sg/property-agents/JohnnyTan-87867270", description: "Property insights and listings", img: "/ListingPage_Johnny listing-icons/2.png" },
  { name: "99.co", url: "https://www.99.co/singapore/agents/R045634B-johnny", description: "Modern property search platform", img: "/ListingPage_Johnny listing-icons/3.png" },
  { name: "SRX", url: "https://www.srx.com.sg/johnnytan", description: "Trusted property data and listings platform", img: "/ListingPage_Johnny listing-icons/4.png" },
];

export const frameworkArtwork = {
  clarity: "https://customer-assets.emergentagent.com/job_johnny-tan-realtor/artifacts/jp8z3jsg_Artwork%2001%20The%20CLARITY%20System.png",
  water: "https://customer-assets.emergentagent.com/job_johnny-tan-realtor/artifacts/qabp65ao_Artwork%2002%20The%20WATER%20Concept.png",
  clear: "https://customer-assets.emergentagent.com/job_johnny-tan-realtor/artifacts/635vhufr_Artwork%2003%20The%20CLEAR%20framework.png",
  lex: "https://customer-assets.emergentagent.com/job_johnny-tan-realtor/artifacts/cmfb600c_Artwork%2004%20LEX%20method.png",
  journey: "https://customer-assets.emergentagent.com/job_johnny-tan-realtor/artifacts/x1slwxis_Artwork%2005%20Property%20Planning%20Journey%20JT01.png",
};

export const externalLinks = {
  propertyValuation: "https://propertyportal.era.com.sg/evalue?refer=87867270",
};

export const pageMeta = {
  home: { title: "Johnny Tan | Strategic Property Advisory in Singapore · johnnytan.sg", description: "Strategic property advisory by Johnny Tan — HDB & condo specialist, investment and asset progression consultant since 2012.", keywords: "Johnny Tan, Singapore property advisor, HDB resale, condo upgrading, property investment, asset progression" },
  about: { title: "About Johnny Tan | Singapore Property Advisor", description: "Meet Johnny Tan — Singapore real estate advisor since 2012. HDB & condo specialist, property investment and asset progression consultant." },
  services: { title: "Services | Johnny Tan Property Advisory", description: "Consulting services and marketing solutions for Singapore property owners, upgraders, and investors." },
  framework: { title: "The C.L.A.R.I.T.Y Property Framework | Johnny Tan", description: "A seven-step advisory framework for clearer property decisions and long-term wealth in Singapore real estate." },
  results: { title: "Proven Results | Johnny Tan", description: "Real client outcomes — upgrades, investments, and exits handled by Johnny Tan." },
  testimonials: { title: "Testimonials | Johnny Tan", description: "Genuine feedback from clients Johnny Tan has guided through Singapore's property market." },
  awards: { title: "Awards | Johnny Tan", description: "Industry recognition and awards earned over a decade of property advisory work." },
  valuation: { title: "Property Valuation | Johnny Tan", description: "Get an instant property valuation through Johnny Tan's official ERA valuation portal." },
  calculators: { title: "Property Calculators | Johnny Tan", description: "Free mortgage, sales proceed, and purchase calculators for Singapore property buyers and sellers." },
  blog: { title: "Property Insights & Blog | Johnny Tan", description: "Singapore property insights — HDB upgrading, condo investment, asset progression, and retirement planning." },
  contact: { title: "Schedule an Appointment | Johnny Tan", description: "Schedule a consultation with Johnny Tan — Singapore property advisor." },
  listings: { title: "Featured Listings | Johnny Tan", description: "Hand-picked Singapore property listings — HDB resale, private condos, and investment-grade units curated by Johnny Tan.", keywords: "Singapore property listings, HDB resale, condo for sale, Johnny Tan listings" },
};
